import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LogoutButton.css';

export default function LogoutButton({ label = 'Logout' }) {
  const navigate = useNavigate();
  const handleLogout = () => {
    sessionStorage.removeItem('token');
    navigate('/login', { replace: true });
  };

  return (
    <button onClick={handleLogout} className="logout-button">
      {label}
    </button>
  );
}